(function ($, window, document, undefined) {
    var defaultOptions = {
        url: null,
        bracket: -1,
        mat: -1,
        csrf_token: null,
        tournament: null,
        style: null,
        category: null,
        backgroundColor: '#9FE085',
        request_type: "GET",
        matTableType: 'wrestlers',
    }

    $.fn.changeMat = function (customOptions) {

        var options = $.extend({}, defaultOptions, customOptions);
        $.ajax({
            type: options.request_type,
            url: options.url,
            data: {
                _token: options.csrf_token,
                id: options.bracket,
                tournament: options.tournament,
                mat: options.mat,
                style_id: options.style,
                category_id: options.category,
            },
            success: function (data) {
                var matAllocated = $('#'+options.bracket+'-mat'),
                    wrestlers = $('#'+options.bracket+'-wrestlers'),
                    matches = $('#'+options.bracket+'-matches'),
                    matRow = matAllocated.parentsUntil('tbody').first(),
                    oldMat = parseInt(matAllocated.text()),
                    wrestlerCount = parseInt(wrestlers.text()),
                    matchesCount = parseInt(matches.text());

                if(oldMat === options.mat)
                    return false;

                if(options.mat !== -1 && options.mat !== 0) {
                    matAllocated.text(options.mat);
                    matRow.css({'transition': 'background-color 0.3s','background-color':options.backgroundColor});
                } else {
                    matAllocated.text('');
                }

                if(options.matTableType !== 'officials') {
                    return $().updateMatTable({
                        mat: options.mat,
                        oldMat: oldMat,
                        matches: matchesCount,
                        wrestlers: wrestlerCount,
                    });
                };
            },
            error: function (jqXHR, textStatus, errorThrown) {
                $().popupError(jqXHR.responseJSON.error);
                console.log([jqXHR, textStatus, errorThrown]);
            }
        });


    };


})(jQuery, this, this.document);
